import { Accordion } from '@cp/ds/src/components/accordion';
import { Typography } from '@cp/ds/src/components/typography';
import { Stack } from '@cp/ds/src/components/stack';
import { Button } from '@cp/ds/src/components/button';
import { StyledUnorderedList } from '@cp/ds/src/components/styled/styledUnorderedList';
import { StyledListItem } from '@cp/ds/src/components/styled/styledListItem';
import { RoutedLink } from 'src/shared/ui/link';
import { faqSectionData } from './constants';

export const FaqBlock = ({ isMobile }: { isMobile: boolean }) => {
  const AnswerList = ({ item }: { item: string[] }) => {
    return (
      <Stack gap={'10px'}>
        {item.map((el, i) => (
          <Typography component="p" key={i} sx={{ typography: { xs: 'body', md: 'button secondary' } }} variant="button">
            {el}
          </Typography>
        ))}
      </Stack>
    );
  };

  return (
    <Stack
      sx={{
        width: '100%',
        alignItems: 'center',
        gap: { xs: 2.5, md: 6 },
        pb: { xs: 2.5, md: 7.5 },
        mb: '10px',
      }}
    >
      <Stack
        component={StyledUnorderedList}
        itemType="https://schema.org/FAQPage"
        sx={{
          maxWidth: '850px',
          width: '100%',
          m: '0 auto',
          gap: { xs: 1.5, md: 2.5 },
        }}
      >
        {faqSectionData.map((el, i) => (
          <StyledListItem itemProp="mainEntity" itemScope itemType="https://schema.org/Question" key={i}>
            <Accordion
              details={<AnswerList item={el.answer} />}
              summary={el.question}
              summaryTypography="h1"
              summaryTypographySx={{ typography: { xs: 'h3', md: 'h1' } }}
              sx={{
                p: { md: 2 },
                borderRadius: '20px',
                backgroundColor: 'gray ultra light',
              }}
            />
          </StyledListItem>
        ))}
      </Stack>
      <RoutedLink href="/faq/" sx={{ display: 'contents' }}>
        <Button as="span" size={isMobile ? 'small' : 'normal'}>
          Все вопросы и ответы
        </Button>
      </RoutedLink>
    </Stack>
  );
};
